import { statisticsApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import RenderProfessionalDetailsGrid from './RenderProfessionalDetailsGrid';
import moment from 'moment';
import ProfilePicture from './ProfilePicture';
import ProfessionalStatisticsGraph from './ProfessionalStatisticsGraph';
import { useNavigate } from 'react-router-dom';

function ProfessionalStatistics() {
      const navigate = useNavigate();
      const {userDetails, makeApiCallFunc} = useContext(Context);
      const [newProfilePic, setNewProfilePic] = useState(null);
      const [oldProfilePic, setOldProfilePic] = useState([]);
      const [profileStats, setProfileStats] = useState(null);
      const [oldProfile, setOldProfile] = useState([]);
        const [newProfile, setNewProfile] = useState(null);
        
        const findClosedCases = (cases) => {
            let count = 0;
            cases?.forEach(element => {
                if(element.caseStatus === "closed")
                {
                    count++;
                }
            });
            return count;
        }


useEffect(()=>{
    makeApiCallFunc(statisticsApi+"/"+ userDetails._id,
        null,
        (data) => {
            if(data.data)
            {
                const oldProfile = data.data.oldProfile ? data.data.oldProfile.profile : null;
                if(oldProfile !== null)
                {
                    oldProfile?.map((profileEle, key) => {
                        setOldProfilePic((prev) => [...prev, profileEle.profilePic]);
                        setOldProfile((prev) => [...prev, {
                            "Name" : profileEle.firstName+" "+profileEle.lastName,
                            "Email Id"  : profileEle.email,
                            "Company" : profileEle.company? profileEle.company : "--",
                            "Phone Number" : profileEle.phoneNumber? profileEle.phoneNumber : "--",
                            "Experience" : profileEle.experience ? profileEle.experience :  "--",
                            "Designation" : profileEle.legalType ? profileEle.legalType :  "--",
                            "Law Firm URL" : profileEle.lawFirmLink ? profileEle.lawFirmLink :  "--",
                            "LinkedIn URL" : profileEle.linkedin ? profileEle.linkedin :  "--",
                            "Total number of requests made": data?.data?.oldCases?.[key].length,
                            "Total closed cases" : findClosedCases(data?.data?.oldCases?.[key]),
                            "Joined this platform on" : moment(profileEle.timestamp).format("MM-DD-YYYY"),
                            "Changed firm on " : moment(profileEle.createdAt).format("MM-DD-YYYY")
                        }]);
                    }
                    );
                }
                const newProfile = data.data.profile ? data.data.profile : null;
                console.log(newProfile)

                if(newProfile)
                {
                    console.log("newprofile tere")
                    setNewProfilePic(newProfile.profilePic);
                    setNewProfile({
                        "Name" : newProfile.firstName+" "+newProfile.lastName,
                        "Email Id"  : newProfile.email,
                        "Company" : newProfile.company? newProfile.company : "--",
                        "Phone Number" : newProfile.phoneNumber? newProfile.phoneNumber : "--",
                        "Experience" : newProfile.experience ? newProfile.experience :  "--",
                        "Designation" : newProfile.legalType ? newProfile.legalType :  "--",
                        "Law Firm URL" : newProfile.lawFirmLink ? newProfile.lawFirmLink :  "--",
                        "LinkedIn URL" : newProfile.linkedin ? newProfile.linkedin :  "--",
                        "Total number of requests made": data.data.cases.length,
                        "Total closed cases" : findClosedCases(data.data.cases),
                        "Joined this platform on" : moment(newProfile.timestamp).format("MM-DD-YYYY"),
                    });
                }

            }
        },
        (error) => console.log(error)
    )
},[])
  return (
    <>
    <ProfessionalStatisticsGraph/>
    {
    newProfile &&
            <div className='border border-gray-200 bg-ivory rounded-xl mt-4 p-4 lg:p-8'>
            <div className='w-full mb-6 flex items-center justify-between'>
                <span className='font-spectral text-navy text-lg lg:text-xl'>Profile summary</span>
                <span
                    onClick={() => navigate('/attorney/profile')}
                    className='font-plexsans text-xs lg:text-sm font-semibold text-tan hover:text-tanDark underline cursor-pointer transition-colors'
                >Edit profile</span>
            </div>
                <>
                    <div className='font-bold text-tan text-sm underline'>Your current profile information</div>
                    <div className='lg:pt-6'>
                        {newProfile && newProfile?.profilePic &&
                        <img className='flex w-20 mb-6 h-20 border ring-2 rounded-full ring-gray-200  ring-tan' src={newProfilePic} alt="Preview" />
                        }<RenderProfessionalDetailsGrid data={newProfile}/>
                    </div>
                </>
                {oldProfile &&
                    oldProfile?.map((profileEle, key) => {
                    return <>
                    <div className='font-bold text-tan text-sm underline ml-10'>Your past firm details {profileEle._id}</div>

                    <div className='border border-gray-200 rounded-lg mr-10 mt-2 p-10 px-20 '>
                        <img className='flex mb-2 w-20 h-20 border ring-2 rounded-full ring-gray-200  ring-tan' src={oldProfilePic[key]} alt="Preview" />
                        <RenderProfessionalDetailsGrid data={profileEle}/></div>
                    </>
                    })
                    }
            </div>

    }
    
    </>
  )
}

export default ProfessionalStatistics